import React, { Component } from "react";
import { Link } from "react-router-dom";
import { NavLink } from "reactstrap";
import auth from "../../services/authService";

const styleObj = {
    fontSize: "10pt",
    color: "#a12",
    textAlign: "center",
    paddingTop: "0",
    position: "absolute",
    top: "0",
    left: "620px"
}

export class BannerHeaderSecure extends Component {
    
    constructor(props) {
        super(props);
        this.state = { user: null, icRoles: [], selectedRole: "", selectChanged: false};
    }

    icSelectHandler = function (trg) {
        const selectedIcRole = this.getIcRole(trg.value);
        localStorage.setItem("selectedIcRole", JSON.stringify(selectedIcRole));
        //this.props.icTrigger(selectedIcRole);
        window.location.reload();
    }

    getIcRole = (idx) => {
        const icRoles = this.state.icRoles;
        if (idx < icRoles.length) return icRoles[idx];
        else return null;
    }
    componentDidMount() {
        const user = auth.getCurrentUser();
        const icRoles = auth.getUserRoles();
        const defaultIcRole = this.props.defaultIcRole;

        this.setState({
            user,
            icRoles,
            selectedRole: defaultIcRole,
            defaultIcRole
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultIcRole !== this.props.defaultIcRole) {
            const updatedIcRole = this.props.defaultIcRole;
            //console.log('!!!!!!!!!!!!!!! updated props IcRole');
            //console.log(updatedIcRole);
            this.setState({ selectedRole: updatedIcRole, defaultIcRole: updatedIcRole });
        }
    }

    render() {
        const userName = this.state.user ? this.state.user.firstName + " " + this.state.user.lastName : "";
        const selectedRole = this.state.selectedRole;
        const defaultIcRole = this.state.defaultIcRole;

        return (  
            <div>
                <div className="top-header">
                    <div className="nih-details">
                        <a href="#" className="logo-nih">
                            <img src="images/logo-nih-mark.svg" className="logo-nih-mark" alt="NIAID Logo" />
                            <img src="images/logo-nih-niaid-keyline-white.svg" className="logo-nih-niaid-text" alt="National Institute of Allergy and Infectious Diseases" />
                        </a>
	                    <div className="samhsa-logo-container">
		                    <a href="#" className="logo-samhsa">
			                    <img src="images/samhsa_logo.png" className="logo-samhsa" alt="Substances Abuse and Mental Health Services Administration (SAMHSA) logo" /></a>
                        </div>
	                    <div className="cdc-logo-container">
		                    <a href="#" className="logo-cdc">
			                    <img src="images/cdc_logo.png" className="logo-cdc" alt="Centers for Disease Control and Prevention (CDC) logo" /></a>
	                    </div>
	                    <div className="arpa-logo-container">
		                    <a href="#" className="logo-arpa">
			                    <img src="images/arpa-h_logo_white_notagline.png" className="logo-arpah" alt="Advanced Research Projects Agency for Health (ARPA-H) logo" /></a>
                        </div>
                    </div>
                    <div className="user-info">
                        <div className="user-vert-container">
                            <div className="user-name-title">
                                <div className="user-name">
                                    <strong>{userName}</strong>
                                </div>
                                <div className="user-title">
                                    External User
                                </div>
                            </div>
                            <div className="logout">
                                <NavLink tag={Link} className="btn-logout" to="/logout">Logout</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>              
        );
    }
}
